import React, { CSSProperties, PropsWithChildren } from "react";

import Spinner from "~/components/Spinner/Spinner";
import { getLuma } from "~/helpers/colorHelpers";

import styles from "./PageWrapper.module.css";

type PageWrapperProps = {
  pageRef?: React.RefObject<HTMLDivElement>;
  loading: boolean;
  style?: CSSProperties;
};

const PageWrapper: React.FC<PropsWithChildren<PageWrapperProps>> = ({
  pageRef,
  loading,
  style,
  children,
}) => {
  // Style
  const fontColor =
    getLuma(style?.backgroundColor ?? "#fff") < 95 ? "#fff" : "#000";

  return (
    <div ref={pageRef} className={styles.wrapper} style={style}>
      {loading ? (
        <Spinner
          className={styles.spinner}
          style={{
            borderColor: fontColor,
          }}
        />
      ) : (
        <>{children}</>
      )}
    </div>
  );
};

export default PageWrapper;
